import moment from "jalali-moment";

export const getDateNow2 = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let now_today = dd + '-' + mm + '-' + yyyy;
    return now_today
}


export const getDateNow = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let now_today = yyyy + '-' + mm + '-' + dd;
    return now_today
}


export const getDateCurrentWeek = () => {
    const startOfWeek = moment().locale('fa').startOf('week').format('YYYY-MM-DD');
    const endOfWeek = moment().locale('fa').endOf('week').format('YYYY-MM-DD');
    const miladiStart = moment.from(startOfWeek, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')
    const miladiEnd = moment.from(endOfWeek, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')

    // let curr = new Date;
    // let fd = new Date(curr.setDate(curr.getDate() - curr.getDay()));
    // let fdd = String(fd.getDate()).padStart(2, '0');
    // let fmm = String(fd.getMonth() + 1).padStart(2, '0'); //January is 0!
    // let fyyyy = fd.getFullYear();
    // let firstday = fyyyy + '-' + fmm + '-' + fdd;

    // let ld = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
    // let ldd = String(ld.getDate()).padStart(2, '0');
    // let lmm = String(ld.getMonth() + 1).padStart(2, '0'); //January is 0!
    // let lyyyy = ld.getFullYear();
    // let lastday = lyyyy + '-' + lmm + '-' + ldd;

    return [miladiStart, miladiEnd]
}


export const getDateCurrentMonth = () => {
    const startOfMonth = moment().locale('fa').startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment().locale('fa').endOf('month').format('YYYY-MM-DD');
    const miladiStart = moment.from(startOfMonth, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')
    const miladiEnd = moment.from(endOfMonth, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')

    // let date = new Date;
    // let fd = new Date(date.getFullYear(), date.getMonth(), 1);
    // let fdd = String(fd.getDate()).padStart(2, '0');
    // let fmm = String(fd.getMonth() + 1).padStart(2, '0'); //January is 0!
    // let fyyyy = fd.getFullYear();
    // let firstday = fyyyy + '-' + fmm + '-' + fdd;

    // let ld = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // let ldd = String(ld.getDate()).padStart(2, '0');
    // let lmm = String(ld.getMonth() + 1).padStart(2, '0'); //January is 0!
    // let lyyyy = ld.getFullYear();
    // let lastday = lyyyy + '-' + lmm + '-' + ldd;

    return [miladiStart, miladiEnd]
}


export const getDateBeforeMonth = () => {
    const startOfMonth = moment().locale('fa').subtract(1,'months').startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment().locale('fa').subtract(1,'months').endOf('month').format('YYYY-MM-DD');
    const miladiStart = moment.from(startOfMonth, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')
    const miladiEnd = moment.from(endOfMonth, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')
    return [miladiStart, miladiEnd]
}


export const convertStringDateToDate = (date: any) => {
    var newdate = new Date(date),
        mnth = ("0" + (newdate.getMonth() + 1)).slice(-2),
        day = ("0" + newdate.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
}

export const convertDateToString = (date: any) => {
    let month: any = {
        '01': "Jan",
        '02': "Feb",
        '03': "Mar",
        '04': "Apr",
        '05': "May",
        '06': "June",
        '07': "July",
        '08': "Aug",
        '09': "Sept",
        '10': "Oct",
        '11': "Nov",
        '12': "Dec"
    }
    let new_date = `Mon ${month[date.slice(5, 7)]} ${date.slice(8, 10)} ${date.slice(0, 4)}`
    return new_date
}


export const converDurationToMin = (n: any) => {
    let return_time;
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours == 0) {
        return_time = rminutes + " دقیقه"
    }
    if (rminutes == 0) {
        return_time = rhours + " ساعت "
    }
    if (rminutes != 0 && rhours != 0) {
        return_time = rhours + " ساعت " + rminutes + " دقیقه"
    }
    return return_time;
}

export const calculateDifferenceTwoDay = (day1: any, day2: any) => {
    var Difference_In_Time = new Date(convertDateToString(day2)).getTime() - new Date(convertDateToString(day1)).getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return +Difference_In_Days + 1;
}

export const getDayOfWeek = (date: any) => {
    let a = new Date(date)
    let b = a.toLocaleString('fa', { weekday: 'long' })
    return b;
}


